import { getBnySatBaseUrl } from '../../../services/apiService';
import { createApiThunk, apiCall } from '../../../utils/api';

export const amendOrderThunk = createApiThunk('AMEND_ORDER', apiCall);

export const amendOrder =
  (basketId: string, version: number, payload: any) => (dispatch: AppDispatch) => {
    const url = `${getBnySatBaseUrl()}/v1/bny/basket/${basketId}/${version}/amend`;
    return dispatch(amendOrderThunk({ url, method: 'PUT', data: payload }));
  };
